import { Avatar, Card, CardBody } from '@heroui/react';
import { Icon } from '@iconify/react';
import { /* useLocation, */ useNavigate } from 'react-router';

import useAppEvents from '@/patient-app-common/hooks/useAppEvents';

export function MetricEventList() {
  const { isLoading, activeMetrics } = useAppEvents();

  if (isLoading) return null;

  return (
    <div className="space-y-4">
      {activeMetrics.map((event) => (
        <MetricEvent event={event} key={event.id} />
      ))}
    </div>
  );
}

function MetricEvent({ event }) {
  const navigate = useNavigate();
  // const location = useLocation();

  return (
    <Card
      isPressable
      onPress={() =>
        navigate(`/tracker/${event.options.id}`, {
          state: {
            eventId: event.id,
          },
        })
      }
      className="bg-primary-100 w-full"
    >
      <CardBody>
        <div className="flex justify-between">
          <div className="flex gap-4 items-center">
            <Avatar
              color="primary"
              icon={
                <Icon
                  icon="healthicons:cardiogram-e-outline"
                  className="text-3xl text-background"
                />
              }
            />
            <h2>{event.title}</h2>
          </div>
          <Icon
            icon="mdi:chevron-right"
            className="text-xl place-self-center"
          />
        </div>
      </CardBody>
    </Card>
  );
}
